export const tooltipIconContent = {
  ariaLabel: 'Click for more information',
}
